import React, { useState, useContext } from 'react';
import { AsgFwContext, AsgDictionaryContext } from '../../../contexts';
import { GridItem } from '../GridItem';
import { LoadMore } from '../../LoadMore';
import { GamesService } from '../../../../../shared/src/services/games.service';
import { useLiveCasinoState } from '../../../hooks/use-live-casino-state.hook';
import { useSelector, useDispatch } from 'react-redux';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useReadMoreGames } from '../../../hooks/use-read-more-games.hook';
import JackpotThumbnail from '../../GameThumbnails/JackpotThumbnail';

export const JackpotGamesGrid = ({
    jackpots = [],
    gameIds = [],
}) => {
    const AsgFW = useContext(AsgFwContext);
    const Dictionary = useContext(AsgDictionaryContext);
    const [liveCasinoData, setLiveCasinoData] = useState(null);
    const {
        session,
        balance: {
            Currency,
            CurrencySign,
        },
        recentGames,
    } = useSelector((state) => state.player);
    const { isMobile, regulation } = useSelector((state) => state.app);
    const { jackpots: storeJackpots } = useSelector((state) => state.jackpots);
    const { buyWin } = useSelector((state) => state.casino);
    const { goTo, loadGame } = useAsgActions();
    const dispatch = useDispatch();

    // get live casino data
    useLiveCasinoState(setLiveCasinoData);

    // read more functionality
    const { gamesToRender, isMoreGamesBtnVisible, loadMore } = useReadMoreGames({ gameIds });

    if (!Array.isArray(gameIds) || !gameIds.length) {
        return null;
    }

    return (
        <div className="asg-vertical__games-grid casino-vertical-grid jackpot-vertical-grid">
            {jackpots.map((jackpotId) => {
                const jackpot = storeJackpots[jackpotId];

                if (!jackpot || !jackpot.amount[Currency]) {
                    return null;
                }

                return <GridItem key={jackpotId}>
                    <JackpotThumbnail jackpot={jackpot} isMobile={isMobile} />
                </GridItem>;
            })}

            {GamesService.renderCasinoThumbnails({
                gamesToRender,
                AsgFW,
                regulation,
                Currency,
                CurrencySign,
                liveCasinoData,
                session,
                isMobile,
                recentGames,
                loadGame,
                goTo,
                buyWin,
                dispatch,
                Dictionary,
            })}

            {isMoreGamesBtnVisible
                && <LoadMore className="casino-vertical-grid__item--more" clickHandler={loadMore} />}
        </div>
    );
};
